exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-dashboard-widgets-timeseries-chart-time-line-control-___time-line-control__container___13Oyp {\n  display: flex;\n  align-items: center;\n  padding-top: 12px;\n}\n\n.src-components-dashboard-widgets-timeseries-chart-time-line-control-___time-line-control__container___13Oyp input {\n  font-size: 15px;\n  height: 25px;\n  margin: 0 20px 0 0;\n  text-align: center;\n  width: 130px;\n}\n\n.src-components-dashboard-widgets-timeseries-chart-time-line-control-___time-line-control__container___13Oyp i {\n  color: gray;\n  margin-right: 7px;\n  font-size: 22px;\n}", ""]);

// exports
exports.locals = {
	"container": "src-components-dashboard-widgets-timeseries-chart-time-line-control-___time-line-control__container___13Oyp"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/dashboard/widgets/timeseries-chart/time-line-control/time-line-control.scss
// module id = 1729
// module chunks = 0